import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Divider, Flex, Link, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { company, copyright, footerDisclaimer, footerLinks } from '../data/site';
export function Footer() {
  return <Box as="footer" bg="navy.900" color="navy.200" pt={{
    base: 14,
    md: 20
  }} pb={10} data-id="element-68" data-mp="32pp57z2flp3v">
      <Container maxW="1200px" px={{
      base: 6,
      md: 8
    }} data-id="element-69" data-mp="36pzaf9iegbho">
        <SimpleGrid columns={{
        base: 1,
        md: 3
      }} spacing={{
        base: 10,
        md: 12
      }} data-id="element-70" data-mp="3ueik9th3kwbv">
          <Stack spacing={4} gridColumn={{
          md: 'span 2'
        }} maxW="480px" data-id="element-71" data-mp="38quiv78flpl">
            <Text fontSize="lg" fontWeight={600} letterSpacing="0.22em" color="white" data-id="element-72" data-mp="37xv6falryhh">
              {company.wordmark}
            </Text>
            <Text fontSize="sm" color="white" fontWeight={500} data-id="element-73" data-mp="3qd6u9muba935">
              {company.legalName}
            </Text>
            <Box fontSize="sm" lineHeight={1.8} data-id="element-74" data-mp="29yxbr9cr3ek8">
              <Text data-id="element-75" data-mp="2a19qldn7p8t2">{company.addressLine1}</Text>
              <Text data-id="element-76" data-mp="2eyjolhoo2ssi">{company.addressLine2}</Text>
              <Text data-id="element-77" data-mp="2ew734ujpa0ap">{company.addressLine3}</Text>
            </Box>
            <Text fontSize="sm" data-id="element-78" data-mp="3labrlvxno6qd">
              Phone:{' '}
              <Link href={company.phoneHref} color="accent.200" _hover={{
              color: 'white'
            }} data-id="element-79" data-mp="3gapd7j63ckfz">
                {company.phone}
              </Link>
            </Text>
          </Stack>

          <Stack spacing={4} data-id="element-80" data-mp="3v5dhwv3o3euj">
            <Text fontSize="xs" fontWeight={600} letterSpacing="0.16em" textTransform="uppercase" color="navy.300" data-id="element-81" data-mp="3q8dk17gz1iei">
              Navigation
            </Text>
            <Stack as="nav" aria-label="Footer navigation" spacing={3} data-id="element-82" data-mp="33nmw76ipll8">
              {footerLinks.map(item => <Link key={item.to} as={RouterLink} to={item.to} fontSize="sm" color="navy.200" _hover={{
              color: 'white',
              textDecoration: 'none'
            }} transition="color 150ms ease" data-id="element-83" data-mp="huo3izhf4lsg">
                  {item.label}
                </Link>)}
            </Stack>
          </Stack>
        </SimpleGrid>

        <Divider borderColor="whiteAlpha.200" my={{
        base: 10,
        md: 14
      }} data-id="element-84" data-mp="yv92royexstn" />

        <Stack spacing={4} data-id="element-85" data-mp="13sr3is2a11qk">
          <Text fontSize="xs" color="navy.300" maxW="760px" lineHeight={1.8} data-id="element-86" data-mp="13sipuxybxseb">
            {footerDisclaimer}
          </Text>
          <Flex direction={{
          base: 'column',
          md: 'row'
        }} justify="space-between" gap={3} fontSize="xs" color="navy.400" data-id="element-87" data-mp="18lbvrp5jb6rz">
            <Text data-id="element-88" data-mp="1hiukb3ie038m">{copyright}</Text>
            <Text data-id="element-89" data-mp="1mjs9w15q7zk5">{company.entity} · United States</Text>
          </Flex>
        </Stack>
      </Container>
    </Box>;
}